import actions from './actionTypes';
import * as Constants from '../utilities/constants/Constants';
import { string } from '../localization';

const initialState = {
  showSideBar: false,
  activeSideBarTab: null,
  activeTemplatesTab: Constants.inspirationsTab,
  activeMaterialTab: 'material',
  folderListElements: null,
  searchBarIsVisible: false,
  materialIndex: 0,
  colorPickerSource: null,
  colorToSearch: null,
  shouldLoadMoreContents: false,
  showLoading: false,
  searchTags: {
    updatedPatternColor: null,
    updatedText: null,
    updatedPage: 0,
    previousPatternColor: null,
    previousText: null
  },
  searchMode: false,
  searchedContents: [],
  patternCount: Constants.PATTERN_COUNT,
  unsplashData: [],
  vecteezyData: [],
  dreamstimeData: [],
  adobeStockData: [],
  hpMosaicData: [],
  gettyImageData: [],
  gettyImageBackgroundData: [],
  gettyImagePhotosData: [],
  gettyImageObjectsData: [],
  iStockBackgroundData: [],
  iStockPhotosData: [],
  iStockObjectsData: [],
  instagramRetryCount: 0,
  instagramData: [],
  instagramElementsNextURL: null,
  instagramLoginFlag: false,
  addText: {
    id: null,
    customText: null,
    buttonState: false,
    fontPath: [
      {
        name: 'line',
        active: true,
        iconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAArCAYAAAFTKNvHAAAABGdBTUEAALGPC/xhBQAAAalJREFUaAXtWE1OhDAULoateg3HBQkrNmzUg3COWahn4SDqEYC7qFudkikppX3YfjIQXkkmbd//e99r2k7y/PL6I4gvlbyP9zenyJWTc2b0FuS8qqqRbF3X/XoQUISR1Gkx6yKhskjKsnSmSJoeArNFHm62j5YqqZm/viYD1gVt8yEhxTQTU3Q16ohMlHWmUnCNUNgkvC6Pik7ipIRs493hfr7zbIqKBuUMKY+g8sFYhv5/nn0aBPYMhQ0pQ/tZNYvvCHenr0NdHiqXbsh3zs/xaCub5Zrb2qa8uaY2KOmYUjSd+K75Ybxaxj3GD49PvhDB8tCJHur9++vzmIbeu0KdSr2iKLBTFXG+WnNFxwhsXrqx1F7lQoSdx2Ke5yLLsmDbXdeJtm2d+vwwdpa6aRohf0t9/EodM16qlyZ2+ZU6XeOGebrsiVUe5hPAL0CQfwbc3lwfV+utC+RodRETtpZlR8SI8I7AtKYSEbaWZUdEdgg7Xy4UqOgDkrL9F97cA5SywQ5hdgkHtfTSD3WqJVEeO4RjwmjLbF0/Irx1hND4IsJoBbeuzw7hX07kWQNKliThAAAAAElFTkSuQmCC',
        selectedIconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAArCAYAAAGx9MC+AAAABGdBTUEAALGPC/xhBQAAAZhJREFUaAXtWEGOwjAMbBGfgAviC3vuYVn4FQJO+6td4AV8YTkhfgGkwlWaTZzERrUiXAmlSeyMPeO0DfVmu7tVyDU2c4f9b9BkFJx5TrQrmPvT53fP9uO4bvudAQz0rB6dKESNZVE3TRNMEV26C8wXOX3ZNlqMUjd/u48GbBv67ruEYNJNDMahtRX552xPgkOoZYWNyhtChHFUJzDytYuvZbzyfI4wxsqZ5dyTKkdjE/rrkHMKhI3MCpvlzNrPUCy5Lbs6cwFtexZd9kK59+8H3NvKLl2xre3au31sg6LAmKMLktt/P43FMm41Nk+SoS/WG50aLPlLgApo/ES0VVCOZFFfpTdKEcdAhN7g6+4yX1XX2YKc0OS8ryZn//lZJFMRUH32kgsoxVFEUwVNkYZsI0LvWOxrkPqHGJlfAUfRQ7tAvjJfvxKJGkyRDavJDsCAKjsAySIQqqwI7QOABg90GDb3sIetnTKHHRYxfy1jjJ2S50hlPP37qcyvtEvLuDTFUuNVZVOZKs1OlS1NsdR4VdlUpkqzuwPLTUtpbqhZagAAAABJRU5ErkJggg=='
      },
      {
        name: 'arc_concave',
        active: false,
        iconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAArCAYAAAFTKNvHAAAABGdBTUEAALGPC/xhBQAABKJJREFUaAXtWclLNEcUfyMjKOK+MTJRweUgXlTGHBTEBEUPrgcFFfwrkpyS/C3iQQQ35FNUXC4mIUYPLuhBD6KIguI6ehDU+Kvvq/6qq6t62pkeF5yC7n5bvVdv6a6uKs8vv/52kZCQkEaa5gV9aXFBwyZiApzb39/PwKmpKTo7O2NwnMgcGBggXA0NDZxMhgAYvA0NDXHwu4BBkQDP73/8+STRDNRTW1urZRq2IY7Rcw+AG0wQ+ci5gHO1UCU2D2L+z99/aWMuCsuwMSaZ4QQ35Qod4uPjqaenh/Xd2tqiq6srqqmpYfjR0RHNz88zGDdLZ3QUUwahvb09PFgYq6qqaG1tjeER+WybXqbe5mabJ5t+5Pf/8L0C7AR1PHdTBSsdHR2UkpJiMihnAEyLZRQt74icXl5eMiW8mEWNpjwXFxczHl7H+/t7BqMw0NAZlzgCk2VeSbwj6/Xtdnt7K6IM/qCpiqi2LUFwSIi4Oh3aUYqZsqyUiBLRVJtObaCGS0tLKSMjg+7u7ujk5IRWV1eNenaix5HhxMRE6urqUupLTk4mXCUlJQb/+PiY5ubmDFwFhDQsv8Li1Csr7O7upufJnnw+H3tzJycn6eLiQhZjuG2ORaM7OzvsE8Dne5W24eFh02eitbWVvF61b2rqN63it0ZlSEdz0s/WY51iN+hvZpiFuv6nn91w4kU6IprRX2RJEA4Gb754/1v5l4LBoECOPhiorrZOydE3+9XCmxVXzPBrpdj6ax7KclJSElVWVlJOTg6bEM7Pzwnf8f39/VBdTXzbb7UomZ+fT/X19SKJwRgArrq6Ojo9PaXp6WmLjIrgqLja2tqURmWF2dnZbDrUzUiifEjD7e3tlJZmXtthalxeXqbFxUUWZlEh4N7eXvJ4PDLZhNuGGuFNTU01OmAdNzExYeAADg8PaWVlheRU9PX10eDgoElWRGw9FnN6fX1tMSoqOjg4oLGxMYMUFxdHWVlZBi4DWsPp6ekm2fHxcROuQm5ubgj/W7w1Nzdz0PLUGsYrw5uojNN0T/EnD17rmjbHCwv6DRidMk6P/frwSIhPfRJEqSjAn8+wN1D9YxQCaa/y+WeP2MJ8c2M97bV/+OyH5j4XmwG+PN+XN6st911ypjHmsLM4fVypWIY/bu6cjfzTZVj7l+csXnopLCEKCgqovLycMjMz9YIS5+npiW2KbmxssKfEjhh11WEs0gKBANvRDXdkCBT2QHGhPT4+0vr6Om1ubhKCEWlzxWHsJjc1NRnnNpEOSuyPRUhFRQW7sJDB+uLh4UEUeREcscPPZ7RUVFSkNYqs7O7u0vb2Njuk1Ao+M7CcxyuAha6qIetY9OJsEoee4bSwHUbkOzs7CTswqoZNEJzQqc7MVPKgoc/S0hJj45SvsbFRqR8Hsn6/n2ZmZnSqtPSwv9ItLS3KweCdw/kDdnxe4qw8Quw6jIyMGAGQ+bm5uWx3SaaHwsNyuKyszLL5A0Mo39HRUe1hS6jBqPjYTpmdnVWxqLCwkPLy8pQ8HTGsksb7iOu1Gs7unGxoOBlPWBl2ovi9ysQcfq+ZcWtcsQy7Fcn3qufTZfh/lpZy8jYUUG4AAAAASUVORK5CYII=',
        selectedIconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAArCAYAAAGx9MC+AAAABGdBTUEAALGPC/xhBQAABJxJREFUaAXtWUlIlFEc/ztuM66Ymk2aopZYoyRZ2WJhRbQcunSwSydPXYpCIoiKDgVFFHUJAi916RJEl4IWJROz0iyXFstBc9xywWrUycb6/k/f682bb5vF+YjmgX7/999+/+V9y3sTcer0md+gMqJQVvvksaIKUaDSlopzhMztuA0pX9sIzRRQuKbuJGG+W3eYKZioNRXifOXLa5QNTIFxBCJCLYuI8vJyxRQ9XGOANANEYEIaOQZIFfS7FYIFEq1aSUUDfs5i4pl6adYKajATmwxtG4+TacaXejA7h6GncD+ZR7u+QXHjBaoKXsZoyLcMNVMHW4gBVqm9rBqKmi6RuZexaEi05v+JMtX28oZytGqf5Awob9v2HX9XAGX6cg1uqxC5o+wYuCypHkGIxUKhFzK2gxrmv70Jcd8dxAldzLxHj1b15+4kspL6s2By/yR08tgHZowO+Ag8kAdzKogiNSST+X8pw3NPB573j7YqoPuZz98XOuDV6QuYqOvRZVG4kHOPtakXaNRaCiPWtTAVvwSiZ5wQP9ELmd0PAB9weocuYJclTbpFj8r6dEXGgMucAmMZq5k8Znocip7PPSAZUyA0gcVbuLD5unR79wlu5qad64/AdNxi+CkFgnaZn+5DRt8zWV1VYB7U2lMLVvsjWSeUuerFVUJSO8fyPRDjmmCfAFQPr6rA/LOGN9Ki9dgZtqoNAyalxidJqEdAb3R/g/X79eIvINoZ0tswaCAt07Q1pLyqj0W5kGdik8CRtxucydkwEx0PFucgpA28gtSBZjl1WZ7uW2Y8vRjstgOyTigzdmoUbE2X6VTxqgu0fUM1eY0pehEEtqYrEDs1InD/TjV72rbphBcgfkbnvL8D+EmN2ydx4McAbrGUhmqmQ1nlgO9JOsyTw0Dfo5RHr5OJWfC+9BCdkqvSK081Ux7Q4hxSBEQE/MrAfQE/6H6B5yGtCIoLhx/8vp/n8zTuJ6w9dYxF9xmMMU8ogjrydjFduY0IEwqE1f5Q4HhPVXvqrR4cjmKmwXEv7yUMKl+XIHENKW+UYV+D/h6IBanaIXFj6KY9JBkKIIasYSGGkE3DyYas1CEGCnc2xAUPGZzPuyrdkUWYYDy9CIayt8BkwlLdZqgY96MfMnrrpdOxdoDfsz7ZqikHNVl3lBm+rNjncaCpBq4kw+LYV1WCHSqJyqKhN7Cs6x5E/ppWMtHFD0qyeKL7saRK2sQl6QL1VQlPg/EPj6ILWmtUd6hqvgNOtmt1FXxPyVPGkJZhmnRwsLivAcyTX5X1JMl0XDoMZ22WztxLAaTbQBxYTNwZJ453w4o3NaJYc+53sngK0iH9aDlrkneRMNED+W23pKU3pRkEVcBiZH+8S/7cURb4XHwQfiTnUDG7YnFbt54FW+NF8iMEE2gQ3uXTMECxW/qxoVOqsFyiptlf5BSm4PUNnxIVYbFI6ANPdNCnOBAbY8BY9A6/knXk7wWsvDgwqOKG89I9NSqK/J6jL/QplzDGgLHoHfJrUMOaLjUNtaCJI90uKHl6JmB/fnU2YFSDHISTNajwCw4b7uyCl9gggP+qs38A5QhnEGDTsCgAAAAASUVORK5CYII='
      },
      {
        name: 'arc_convex',
        active: false,
        iconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAArCAYAAAFTKNvHAAAABGdBTUEAALGPC/xhBQAABKpJREFUaAXtWdlLc0cUP9EoirgvKIhCFUFREMWPQu2DVVQUd1F88t9oC13+i+9Z0DfBDRFcKjYptoqCCyooIoIbigs0Ctal+Q2d27nbJJObzyhkIJkzc/Zz5s7q+v6HH/+Ji4tzk01hiMXfFmzQRDEcMzg4yEHq7e3VYJ1oEN3e3lJSUpKZYGhoSOsUAU2F2CnCrp9+/uVV7BBhV21trS2SiRYtBydva5zomJ+fp4aGBuJGakhRF4elFrsQc6/nd11gOGegWipZibm4uJh5Gh8fb+KDwzwKHKkz9+DggPDr6uqilJQUTsNqHiGxU8fMEWNjYxyU1tL0Sjn9SGmeZMxfFRX9P7hlhHa48KXKmApRI3DV1dVil9lsKwEDAwOMaW1tTcccW1BQ8Cvv2dnZoYqKCqqsrCS3282+27a2NoqNjaWTkxM6PDzkpJSekWEdbaP26elpurq60hgBINofNFWOvmddEBQajkengi4TqaORbZKm0BExxZbzFwwXx/bu7i6trKwE5Y/INzIyQk9PT5Z8th6Ls2xpaSkzJCsry1IIOvv7+3XGTk5O2ioFva3HQEJ5YmIi9fX1oUmtra2slv2dnZ3R7OysjIThpIpB8fDwoK3CaGMhKykpoQz//HN/f08XFxe0urpKj4+PQAddAio2SuKLoLFftW2bY1VBqvTM47rv6lX5HNM7WtFD1e772/fZ/YfXozwwQlXI+T59+tq8JHPkl64jNriiir90ajX5EQu15ZRZX19P+fn5zLpgJ33uirgsiiscx/Pa0uP19XWOp7y8PA0OBDQ2NmokLy8vGmwFWCq+ubnR0eJUFKgkJyfrjJyZmZGyWCoGx+LiosaIo1hnZ6fWNgL+rT11d3dr3fDWuBPXkP8BljkG7vj4mO7u7ig1NZWRokb+IHBvb49Ns0gDdifGMjw8bOwytW0Vg3J8fJw6OjooLS1NY8T2x3/Y19pGAPus11fbuwCN3DbUnGJiYkIXdt5vrC8vL9lOxW5zZ6SXesyJEXZ8GrhCqaqqopycHEpISKDr62vCDvTo6IiTBl0HpZhL8/l85PF4eNNRHTDUjqRLmKOKJcEJL8r9Te234ZUYhDT/Zo/YwXzlrz/dqieBIOS/KxJcBmRlZn+O2KCOVDSiDkcq8m+lN5rht4p0pPREMxypyL+VXqXdZVlZGdXU1Jhsw8Z9dHSU3fCZkA46cnNzqampyVLC3NwcnZ6eWuJknUpDGk8seBI1FpfLRT09PZSenm5EhdzG+c/OWZwbQnEWxig5DIapqSnCOcJYYmJiqL29nVpaWsjqYdJIb9fGQRiP0HV1dZYkuCNeWlqyxAXTqTSkIRAnbQxfnE+L/Ns1Y8nOzia8yGGY7+/vE0YFDteyAp7y8nJCVmUFL3zb29sykoA4ZYe5RK/XSzCgubnZ9FIMGgxz3N7j57TgtmlhYYGen5+dipK/fwSSjicKvG7jyRSTWTic4zoxkjY2Nmhrayuo2wzOF6gOOcOiYNx0LC8vsx8yW1hYyIZoZmamSCaF8Qmcn5/T5uYmq6XEDpBhcVjUD8Mxi+L3HovyLP0enVCxKeqwSrQ+Im00wx8xayo2/wsW9nwqgwgRpAAAAABJRU5ErkJggg==',
        selectedIconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAArCAYAAAGx9MC+AAAABGdBTUEAALGPC/xhBQAABJJJREFUaAXtWUlPFEEUfjBsA6IZBWEYBdHoQRg3RIxC4hITT8ajJy8aEy8ajQfjxkljjNFf4MWT8WQ8uMQ1GhfiEhFQgwoRAyMITlRgGBC0X5kqq7qrqrunJzMkTiWdrnrvfW+t6q7qzjp+ovk3aFoO8u7dvaMUyaaclxtO0i50L93B+kQDHaFQ4c9eGC0OQfWbS4TMBFbdP0rlhDszIVC5QZYuiqzGxkZliEQ17zlqpWOGRMKi1xfh47KdQJ1kTM4P1tV6TLzVpZSpkXS0miXyAkkA91VvIZFO+fIEIRxgwDQLlMnKhISK7lvk6mg4CHH/HCpD7jRDPFEAU0ZNyzna1d615dUiDaa2Tjrwxk2bQUiYTljGSx7YXAreGvLaGw7xJKvbMgVv6/cRUG3LWTU4/OQMYaKC3kVbYah8FZkYsaIyyI3/EIA4EOqcG/9OlguC++c3MeHqjksQ+NrGxrQjgClRNpsoj78nL9u8Vid9T+vZiQGZjOfZKVPqlOYp106NyOTSZlg6NdFDfmUFP92DYPdtmeMWGo9TrQcEKSPm10WkaiNxZLR4nsUQJbxZs19wNvThunQRUnllxCiAxuP+EuhoOEDk39XtpTjlPW8sCrVPxWeNTFhrGAH5sUH2FsbxULAOBoOrIVZUDrkTI1D0vQdCXTekzyeUVzVbw2bgnMgLwMtrU9bYq2I7PIkYnySpbp7e6Ik6m/BOIFGDiEtLbTNGvZTMFvv/pFf6SMTd5rg/QNIUGGhj5zjbvBkC/GuPf4PxWGl6Q103mUx0bpj17ToR45TjpEmNmjepdMusU4jHqUjVBiZS/uk+65s7UqMohC9n2nCrjS9vVcOX/qumZoGNxzNV0z4G29Ydhom8YgGL5/XS3qeQMz4Cw4FqYStPBfGcgNt9VdMaRVD7WmNSFfydVColPL2m5TzZCPA0c9/WKAKipWHorvn3ucKsBMf5sSFwfFjVfW4wK5/Inwm9C7fCyKxKmMgtAv/IFyiJPHe9q3AUqdm417Fy9npVrMNnjOqy45mXk7bdYKIfxDyHnEIFaT20pzBOZiotq5VZT3EnE2yKE54yc5nKpizVKTb0X1VWeppTJbxnyXYYrKi3sLOnfkH40SnwTcYtPC+ESV8+tK0/AlPZVjdL+p5BZecVV+pdVTb08Rr4fsUsBtAZdMr8i8si6IKAulSBog/oi9vmKljf5DgsNY5PWElzw4Dxn17nyj0wmeM3sx2PEYs6UJesomgbfUBf3Dbr/LDRgB+FVzxohvfLd8HPwEKL9PCsKmhtPAbwewpKvryAuZ8fQcHoV4scTxgrLIWBeeuND891xj9Gdf6Lo12wuPUCD3XVdx0s1Y5G8RN958rdlhM9kTGcHgzWk4tiEr3jn8Alry7YHsjt9CccLCrG3wLhx6eNaVsAnxdvg29ly+3sueLP7m+F+e+vGs+JMVc4lbCnYKlSdGbB28vkwmkYLa2F/somGJ1RQUUc3QuH+6Cs56HxR6idLANHIBdCSQlWsGes1cDAa3IJ9GkwUD8NpoFzyXYhE2yyMzpd9GUqO10qkWw//gBxR1ycpm5BYwAAAABJRU5ErkJggg=='
      },
      {
        name: 'arc_circle',
        active: false,
        iconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAArCAYAAAFTKNvHAAAABGdBTUEAALGPC/xhBQAABK1JREFUaAXtWr1LXEEQ3zsP/AAvwUIEQSzuglhYqIjIJWJpq2Dhf2KR5L8REUQ7rZNDxMLCQgQtRBDEwkLh7gQ18bc6j7l5+56zvtWTmIFkv2bmN7O7b3dmz9z3Hz//mBQqYKz6+1ciS56PLC4umvb2dtPR0RF1NzGsra2Zm5sbMzc352bI5XIGWpaXl90MjUajaRBcuTQvCirrFxYWLB6wiSLLCwU7Debu7o7GTG5mZiaaOWlx02Ak8lSx1qYZJQV4+9EQ3vNUhwNk597enjk8PIxxOYWl7dPT02Z0dDQ2yU5hIEHB2dmZ6evrM21tbTFBmOEUhokuM6XdqcsrmWU7dfklM2+Xyl9MtAP4gLbu9BnCfI/xfc4VO5EheHp6Gs0wV5QqPDg4aMer1aotk1AxGEO+urqyQpr/Yj5fXl5aOZiKtR4aGkrUE0MGJ0yt1+tWEAqSTI8hE8z6+jpVE0snciK3GMj0PQtd6mbm3alGcjAmzrWDt6kL+xB3w8XFhaGd0cTwTMMLOOnrIIyTkxOzvb1NzdRSDUyg+Ezpa+OaMY5Z6O3tNRsbG3zIWVftTP5RuUChmQ7arq4uJ5DsVAGTUgiT51xRqVSKvnjOy3lkXT3VOAmmpqbsdLrAoXhlZcXc399LDGdbDQxpbBzt5nGisU7VVDP+YFXrceXrt2AKtYoy3ehaEMnXqNeWXhwNSGU+7fHx8fit6qMgC2/LNlfLgL2+Y5ranp4eeyYjvcDF8BLyAsaZjTCbE06z29tbs7q6yrufraunGgASlLQjeUg6RolHliqPceHjyiOiHBDtSqViBgYG7BAyGK3nKo9nZ2cJ04aNSDyJcE3ijgZR2kRjaaUKuLOz0+pAVuQifkfzmXHxUp8KmJivr6+pmljyHD2R6WHAC7hcLjt14VGACMGfhlTAFFUg8US0IWl+fj7q0kacql2NzJfiromJCTM2NmaOjo5Md3e36e/vj0DBpyWVx1CGsIYInsMQDooTjGaG+NJKlcdQgFgKcRcOEfIe/cjQNjc3DY5PH1IDk1JMp8+Ukpws1VMtBbO2Px5woRUR5kOw9/gs+NKHtqzr/JbyeAz4/Km41LK99ZbOcqz/DvPZ+BfrH26FvW9E31VH3Dc8PGzD7qTHoFqtZqPjg4MD7yvd155XcTifz5vJycmmvCPNMEwE4hmKaRBA7ezsqN+O0nTLseAOw+ikrA4/WZ2fnxvKCBCe0g813DCkIfiH2MoncuQ6kupBHZaRJ4Hu7u6a4+NjajpLJAiI1TlBH1Y/RFBJeoMdWniVoC1JyrGiSKGfcxb84AEv/+ES/dAJ3aEomMN4FpeErIqn7nJctsELGUku3ZJH2w7msCthwjfqSy4Zl25fvcQfzGGcrMgWOSF1xUuQlsDL013I4cqC7lAUzGEYhNQYD3uc8OyF9zY4w59HiAd9GAMPPZHRGHRtbW1RM0gZ9JTG1sNbHv0+wy2EM9IhPi7rWNVQP7Vw3UEdJsX0uxBO2JGREfXbIlZ0f38/+N1LdqF8FYcJAEEDDxxwvRSLxehPgbAj8JcE2kc40pulfFWHpWFw7C2dk/hoBz20XADvre+/w+9tRULb8xd5B6j4lKmQfQAAAABJRU5ErkJggg==',
        selectedIconPath:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAArCAYAAAFTKNvHAAAABGdBTUEAALGPC/xhBQAABPNJREFUaAXtWstLlFEUPzPNmKWOmT3UIp18BIkQakZlkZsiIlpEm/6CVu0KCioX0SKodf0N0SKiRa2iTLEXibhI8xVlVpo4atqMafO7eb7u3Lnf5/1mPhtBD4z3dZ73ec759F25em2eHCCAsZbnz2xR/PJI+8FmigXWUyyYY3UnINS236Tg7E9623BBj0A+H4HLvhfNeoRgbCphEFg+JysCRtq/3n9ZyINsBkvz3/4s0eefm+Ux8jU1NVkzp2qcMGiRLFSEtk5KqQRyW6yH3MF1GMB67uh/QsVDrTxklVpiVffu3WfpY/ho0iRriSEJDArGumk8fyfN+QNJhBCvJYaKOjUtfRcqjsurIqttx+VXkeV2RWUVWTtAHjCta20GsbzH5H0uM9ZKBuHGkS5rhmVGjsSjm2vEeOX7e6K0k4rBJMnZ06OCyORPks05k0OCDqpirb+UHLDlkyQZmFA1GJ0QhEVDbZbtKpckyYxQ++oWV21LrWRbbGUgrfOs8DJupr07jSVpEG3nWoOb0IV9GA3mUSjSTzmTXxLGTBquBNudDhZU+L2TKrrvc9OxNBbMQnFM+bTJnDGOWYiESqn29W15SFs32pnyodIJBefi+NkBxNaGRLnYHyPB8u3NlsuMvxXVxQ/uftGFw2sCxlONm+FD1WkxnTrhELa39Tr55/+92k4KGAsGE2wc083jJBRjRlO9GJNUxoXFjYcOp0KbFk1aL3qqkmemf15K2RtIVSjo6uvrM7fGGdtcGRPs6hzzuk7lFsfv5DBlxSYID0Mq4Eow7my42TLgNlszF6X6thty96J146mGAFUoc0fwYHeNMo5aGlmMYJAdUDDgGBD1nl1n6MemalQJEYyp5UYWd+45Jxjjj3Aj44EnA55JvNEADpt4zKk0EhzLyhM8EBXpQH6j5ZnR4XKfkWBGzp4e4aptGQ3m2o7JA64Efy1qkGmtOpICDKHIAFcdSyPB7FUg8IS3ocLbfRetLlOP02hXl/Y/puEF16a//CQNho/T1uGXNLNuE40VVFlCESGbgpHFYAa3hgGW4zKRheIGk30zxrUrjSwGMXwpHKXB8DHLevQjQqt5d4eQnXEDxoKZKaYdv3TBeKrTFaTSrzzBgUx4mHFn729aMNVEm7puy7mNZMCG/NCljO2tTE3OqsGZmvn/JXfFrbDrF9HtSsAdH9reSKOF1bbJoOCvCBWOdlHJpxbXT7pbfZbE4DlfgPoqTyXEHU6KISsGb449OjhQO3seGOeOnHirY54brAslWSg+WeWP9xFHBHBP+UMN46BEGIKf3acjGddt3VODVc+TlQn3PqQtw2+4qS0RIMBXlwHhcHRtnidOJfP17NKayi2xtqTFPL6iCKEXMxb4wAGu/OES/djm4O0VeGZwJFSWpBOiKnwzNgXggkYFHW8Vx7TtmcHIN6mAM+oWdDQ63m75Mr5nBuNmRbQoA0JXZIJMAbhyuAs68WSlmLjTyfX00qrpuEsddecTMk1Ie7XHf8hClfU+StriSJkMlJ+w0mOykkgSgqeX4KnBweikyOXx9xlZURjOOT+5366OHePVpxZZhqcGM2P+LoQ3+XPpkYQVZxxdiRXdNvjUVdZGx8epb0kMZoFIN8kpJzwvM+sKxede4OAywn8S8D8EMN1SlktqsKo4DPufxqny0fbsltYxX459qwYvx1XxUqc/Sq6rDy6We+wAAAAASUVORK5CYII='
      }
    ],
    fontId: null,
    selectedFontPath: 'line',
    textColor: '#000000',
    shadowColor: 'none',
    shadowText: string.NO_SHADOW_KEY,
    // textAlign: { value: 'middle', label: string.TEXT_ANCHOR_MIDDLE },
    textAlign: 'middle',
    loaderState: 'd-none'
  },
  upload: {
    file: null
  },
  uploadErrorFlag: null,
  inspirationCategory: [],
  inspirationDetails: {
    previewImage: null,
    dataJSON: null
  },
  inspirations: {
    portraitInspirations: [],
    landscapeInspirations: [],
    offset: 0,
    category: Constants.allInspirationCategory
  },
  documentColors: [],
  uploadInfo: {
    uploadArray: [],
    userPhotoUploadType: {}
  },
  uploadDialogue: false,
  isUploadLogo: false,
  isLoadingIcon: false,
  activeTheme: null,
  dropboxUploadDialog: false,
  dropboxfile: [],
  dropboxFileIndex: 0,
  minimumViewingDistance: null,
  recolor: null,
  recolorArray: [],
  triggerRedraw: false,
  isMaximumLimit: false,
  pattrenDesignCost: {
    price: null,
    currency: null,
    currencySymbol: null
  },
  fileSize: null,
  uploadStatus: null,
  handleBottomBreadcrumbClick: '',
  loaderCoordinates: { left: null, top: null },
  dropBoxErrorFlag: false,
  dropBoxErrorDict: {
    header: '',
    contents: []
  },
  tabTime: 0,
  tabName: null,
  solidBackgroundColor: null
};

export default function sideBarReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SIDEBAR_VISIBILITY:
      return { ...state, showSideBar: action.payload.value };
    case actions.CHANGE_SIDEBAR_TAB:
      return { ...state, activeSideBarTab: action.payload.activeSideBarTab };
    case actions.SET_FOLDER_LIST_ELEMENTS:
      return {
        ...state,
        folderListElements: action.payload.folderListElements
      };
    case actions.SET_TEXT_ID:
      return {
        ...state,
        addText: {
          ...state.addText,
          id: action.payload.id
        }
      };

    case actions.SET_CUSTOM_TEXT:
      return {
        ...state,
        addText: {
          ...state.addText,
          customText: action.payload.customText,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_FONT_FAMILY:
      return {
        ...state,
        addText: {
          ...state.addText,
          fontId: action.payload.value,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_FONT_PATH:
      return {
        ...state,
        addText: {
          ...state.addText,
          fontPath: action.payload.fontPath,
          selectedFontPath: action.payload.selectedFontPath,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_TEXT_COLOR:
      return {
        ...state,
        addText: {
          ...state.addText,
          textColor: action.payload.value,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_SHADOW_COLOR:
      return {
        ...state,
        addText: {
          ...state.addText,
          shadowColor: action.payload.value,
          shadowText: action.payload.text,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_TEXT_ALIGNMENT:
      return {
        ...state,
        addText: {
          ...state.addText,
          textAlign: action.payload.value,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_TEXT_ATTRIBUTES:
      return {
        ...state,
        addText: {
          ...state.addText,
          textAlign: action.payload.textAlign,
          shadowColor: action.payload.shadowColor,
          shadowText: action.payload.shadowText,
          textColor: action.payload.textColor,
          fontPath: action.payload.fontPath,
          selectedFontPath: action.payload.selectedFontPath,
          fontId: action.payload.fontId,
          customText: action.payload.customText,
          buttonState: action.payload.buttonState,
          id: action.payload.id
        }
      };

    case actions.SET_LOADER_STATE:
      return {
        ...state,
        addText: {
          ...state.addText,
          loaderState: action.payload.loaderState,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_UPLOAD_FILE:
      return {
        ...state,
        upload: {
          ...state.upload,
          file: action.payload.file
        }
      };
    case actions.SET_UPLOAD_FILE_STATUS:
      return {
        ...state,
        uploadDialogue: action.payload.uploadDialogue
      };
    case actions.SET_OR_HIDE_SEARCH_BAR:
      return {
        ...state,
        searchBarIsVisible: !state.searchBarIsVisible
      };
    case actions.SET_COLOR_TO_SEARCH:
      return {
        ...state,

        colorToSearch: action.payload.value
      };
    case actions.ELEMEMT_LIST_UNMOUNT:
      return {
        ...state,
        searchBarIsVisible: false
      };
    case actions.SET_SHOULD_LOAD_MORE_CONTENTS:
      return {
        ...state,
        shouldLoadMoreContents: action.payload.shouldLoadMoreContents
      };
    case actions.SHOW_LOADING_DIALOG:
      return {
        ...state,
        showLoading: action.payload.showLoading
      };

    case actions.SET_SEARCH_TAGS:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          updatedPatternColor: action.payload.updatedPatternColor,
          updatedText: action.payload.updatedText,
          updatedPage: action.payload.updatedPage
        }
      };
    case actions.SET_OLD_SEARCH_TAGS:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          previousPatternColor: action.payload.previousPatternColor,
          previousText: action.payload.previousText
        }
      };
    case actions.SET_SEARCH_CONTENTS:
      return {
        ...state,
        searchMode: action.payload.searchMode,
        searchedContents: action.payload.searchedContents
      };
    case actions.FETCH_UNSPLASH_CONTENTS:
      return {
        ...state,
        unsplashData: action.payload.unsplashData
      };
    case actions.FETCH_ADOBE_STOCK_CONTENTS:
      return {
        ...state,
        adobeStockData: action.payload.adobeStockData
      };
    case actions.FETCH_HP_MOSAIC_DATA:
      return {
        ...state,
        hpMosaicData: action.payload.hpMosaicData
      };
    case actions.FETCH_VECTEEZY_CONTENTS:
      return {
        ...state,
        vecteezyData: action.payload.vecteezyData
      };
    case actions.FETCH_GETTY_IMAGE_CONTENTS:
      return {
        ...state,
        gettyImageData: action.payload.gettyImageData
      };
    case actions.FETCH_GETTY_IMAGE_BACKGROUND_CONTENTS:
      return {
        ...state,
        gettyImageBackgroundData: action.payload.gettyImageBackgroundData
      };
    case actions.FETCH_GETTY_IMAGE_PHOTOS_CONTENTS:
      return {
        ...state,
        gettyImagePhotosData: action.payload.gettyImagePhotosData
      };
    case actions.FETCH_GETTY_IMAGE_OBJECTS_CONTENTS:
      return {
        ...state,
        gettyImageObjectsData: action.payload.gettyImageObjectsData
      };
    case actions.FETCH_I_STOCK_BACKGROUND_CONTENTS:
      return {
        ...state,
        iStockBackgroundData: action.payload.iStockBackgroundData
      };
    case actions.FETCH_I_STOCK_PHOTOS_CONTENTS:
      return {
        ...state,
        iStockPhotosData: action.payload.iStockPhotosData
      };
    case actions.FETCH_I_STOCK_OBJECTS_CONTENTS:
      return {
        ...state,
        iStockObjectsData: action.payload.iStockObjectsData
      };
    case actions.SET_COLOR_PICKER_SOURCE:
      return {
        ...state,
        colorPickerSource: action.payload.value
      };
    case actions.SET_DOCUMENT_COLORS:
      return {
        ...state,
        documentColors: action.payload.documentColors
      };
    case actions.CHANGE_TEMPLATES_TAB:
      return {
        ...state,
        activeTemplatesTab: action.payload.activeTemplatesTab
      };
    case actions.CHANGE_MATERIAL_TAB:
      return {
        ...state,
        activeMaterialTab: action.payload.activeMaterialTab
      };
    case actions.SET_INSPIRATION_CATEGORY:
      return {
        ...state,
        inspirationCategory: action.payload.inspirationCategory
      };
    case actions.SET_INSPIRATIONS:
      return {
        ...state,
        inspirations: {
          ...state.inspirations,
          portraitInspirations: action.payload.portraitInspirations,
          landscapeInspirations: action.payload.landscapeInspirations
        }
      };
    case actions.SET_INSPIRATION_OFFSET:
      return {
        ...state,
        inspirations: {
          ...state.inspirations,
          offset: action.payload.offset
        }
      };
    case actions.SET_INSPIRATION_FILTER:
      return {
        ...state,
        inspirations: {
          ...state.inspirations,
          category: action.payload.category
        }
      };
    case actions.SET_UPLOAD_CONTENTS:
      return {
        ...state,
        uploadInfo: {
          ...state.uploadInfo,
          uploadArray: action.payload.uploadArray
        }
      };
    case actions.SET_UPLOAD_USER_PHOTO_TYPE:
      return {
        ...state,
        uploadInfo: {
          ...state.uploadInfo,
          userPhotoUploadType: action.payload.userPhotoUploadType
        }
      };
    case actions.SET_THEME:
      return {
        ...state,
        activeTheme: action.payload.theme
      };
    case actions.MATERIAL_INDEX:
      return {
        ...state,
        materialIndex: action.payload.value
      };
    case actions.SET_DROPBOX_UPLOAD_DIALOG:
      return {
        ...state,
        dropboxUploadDialog: action.payload.dropboxUploadDialog
      };
    case actions.SET_DROPBOX_FILES:
      return {
        ...state,
        dropboxfile: action.payload.dropboxfile
      };
    case actions.SET_IS_UPLOAD_LOGO:
      return {
        ...state,
        isUploadLogo: action.payload.isUploadLogo
      };
    case actions.SHOW_LOADING_ICON:
      return {
        ...state,
        isLoadingIcon: action.payload
      };
    case actions.TRIGGER_COMPONENT_REDRAW:
      return {
        ...state,
        triggerRedraw: !state.triggerRedraw
      };
    case actions.IS_MAXIMUM_LIMIT:
      return {
        ...state,
        isMaximumLimit: action.payload.isMaximumLimit
      };
    case actions.PATTERN_DESIGN_COST:
      return {
        ...state,
        pattrenDesignCost: {
          ...state.pattrenDesignCost,
          price: action.payload.cost,
          currency: action.payload.currency,
          currencySymbol: action.payload.currencySymbol
        }
      };
    case actions.FETCH_DREAMSTIME_CONTENTS:
      return {
        ...state,
        dreamstimeData: action.payload.dreamstimeData
      };
    case actions.SET_DROPBOX_FILE_INDEX:
      return {
        ...state,
        dropboxFileIndex: action.payload.dropboxFileIndex
      };
    case actions.SET_UPLOAD_FILE_PERCENTAGE:
      return {
        ...state,
        uploadStatus: action.payload.uploadStatus
      };
    case actions.SET_FILE_SIZE:
      return {
        ...state,
        fileSize: action.payload.fileSize
      };
    case actions.SET_INSTAGRAM_CONTENTS:
      return {
        ...state,
        instagramData: action.payload.instagramData
      };
    case actions.SET_INSTAGRAM_NEXT_URL:
      return {
        ...state,
        instagramElementsNextURL: action.payload.instagramElementsNextURL
      };
    case actions.HANDLE_BOTTOM_BREADCRUMB_CLICK:
      return {
        ...state,
        handleBottomBreadcrumbClick: action.payload.value
      };
    case actions.SET_UPLOAD_ERROR_FLAG:
      return {
        ...state,
        uploadErrorFlag: action.payload.uploadErrorFlag
      };
    case actions.SET_INSTAGRAM_LOGIN_FLAG:
      return {
        ...state,
        instagramLoginFlag: action.payload.instagramLoginFlag
      };
    case actions.SET_LOADER_COORDINATES:
      return {
        ...state,
        loaderCoordinates: action.payload.loaderCoordinates
      };
    case actions.DROPBOX_ERROR_FLAG:
      return {
        ...state,
        dropBoxErrorFlag: action.payload.dropBoxErrorFlag
      };
    case actions.DROPBOX_ERROR_PARAMS:
      return {
        ...state,
        dropBoxErrorDict: action.payload.dropBoxErrorDict
      };
    case actions.TAB_USAGE_DURATION:
      return {
        ...state,
        tabTime: action.payload.tabTime,
        tabName: action.payload.tabName
      };
    case actions.SET_SOLID_BACKGROUND_COLOR:
      return {
        ...state,
        solidBackgroundColor: action.payload.solidBackgroundColor
      };
    case actions.SET_INSTAGRAM_RETRY_COUNT:
      return {
        ...state,
        instagramRetryCount: action.payload.instagramRetryCount
      };

    default:
      return state;
  }
}
